import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { CaseTypeLite, Jurisdiction } from '../../domain';
import { AbstractAppConfig as AppConfig } from '../../../app.config';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { HttpErrorService } from '../http';

@Injectable()
export class DefinitionsService {

  constructor(private httpClient: HttpClient, private appConfig: AppConfig, private errorService: HttpErrorService) {}

  getCaseTypes(jurisdictionId: string, access: string): Observable<CaseTypeLite[]> {
    const url = this.appConfig.getApiUrl()
      + `/caseworkers/:uid`
      + `/jurisdictions/${jurisdictionId}`
      + `/case-types?access=${access}`;

    return this.httpClient
      .get<CaseTypeLite[]>(url)
      .pipe(
        catchError(error => {
          this.errorService.setError(error);
          return throwError(error);
        })
      );
  }

  getJurisdictions(access: string): Observable<Jurisdiction[]> {
    const url = this.appConfig.getApiUrl()
      + `/caseworkers/:uid`
      + `/jurisdictions?access=${access}`;

    return this.httpClient
      .get<Jurisdiction[]>(url)
      .pipe(
        catchError(error => {
          this.errorService.setError(error);
          return throwError(error);
        })
      );
  }
}
